import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SideBar from '@/components/Layout/SideBar.vue';
import Footer from '@/components/Layout/Footer.vue';
import InfoBtn from '@/components/InfoBtn.vue';

var Layout =
/** @class */
function (_super) {
  __extends(Layout, _super);

  function Layout() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.drawer = false;
    return _this;
  } // Props
  // Data
  // Hooks


  Layout.prototype.mounted = function () {}; // Methods


  Layout.prototype.swipe = function (direction) {
    if (direction === 'Right') {
      this.drawer = false;
    } else if (direction === 'Left') {
      this.drawer = true;
    }
  };

  Layout.prototype.toggleDrawer = function (lists) {
    lists = false;
    this.drawer = !this.drawer;
  };

  Layout = __decorate([Component({
    components: {
      SideBar: SideBar,
      Footer: Footer,
      InfoBtn: InfoBtn
    }
  })], Layout);
  return Layout;
}(Vue);

export default Layout;